import { render, staticRenderFns } from "./WishlistStandingOrders.vue?vue&type=template&id=5be1a550&scoped=true&"
import script from "./WishlistStandingOrders.vue?vue&type=script&lang=js&"
export * from "./WishlistStandingOrders.vue?vue&type=script&lang=js&"
import style0 from "./WishlistStandingOrders.vue?vue&type=style&index=0&id=5be1a550&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be1a550",
  null
  
)

export default component.exports